import React, { useEffect, useState } from 'react';
import StatsJsx from './Stats.jsx';
import { generalStats } from '../../api';
import Loader from '../Loader/loader';
import {
  handleFilterChangeUtil,
  handleFilterClearUtil,
} from '../../util/filter-utils';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

const Stats = () => {
  const [serverData, setServerData] = useState({
    age_breakdown: {},
    gender_breakdown: {},
    tests_breakdown: {},
    travel_breakdown: {},
    travel_word_cloud: [],
    deprivation_breakdown: {},
    ethnicity_breakdown: {},
    gender_identity_breakdown: {},
    sexual_orientation_breakdown: {}
  });
  const [isLoading, setIsLoading] = useState(true);
  const [filtersLoading, setFiltersLoading] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState({
    date: 30,
    completed_by: 'all',
    age: []
  });
  const [customDateActive, setCustomDateActive] = useState(false)
  const [customFromDate, setCustomFromDate] = useState()
  const [customToDate, setCustomToDate] = useState()


  useEffect(() => {
    if(selectedFilters.date !== 'custom') {
      getStatsData(selectedFilters);
       setCustomDateActive(false)
    } else {
      setCustomDateActive(true)
      if(customToDate && customFromDate) {
        setFiltersLoading(true)
        getStatsData(selectedFilters);
      } else {
        setFiltersLoading(false)
      }
    }
  }, [selectedFilters]);

  // useEffect(() => {
  //   getExistingFilters();
  // }, []);

  const getExistingFilters = async () => {
    const existingFilters = await localStorage.getItem('filters');
    setSelectedFilters(JSON.parse(existingFilters));
  };

  const handleFilterChange = (updatedFilter) => {
    setFiltersLoading(true)
    handleFilterChangeUtil(updatedFilter, selectedFilters,  setSelectedFilters)
    if(updatedFilter == '1' || updatedFilter == '7' || updatedFilter == '30' || updatedFilter == '90' ) {
      setCustomDateActive(false)
    }
  };

  const handleCustomFromDate = (from) => {
    setCustomFromDate(from.target.value)
    if(customToDate) {
      let fromArr = from.target.value.split('-')
      let toArr = customToDate.split('-')
      const existingFilters = { ...selectedFilters };
      existingFilters['toDate'] = customToDate;
      existingFilters['fromDate'] = differenceInCalendarDays(new Date(toArr[0], toArr[1], toArr[2]), new Date(fromArr[0], fromArr[1], fromArr[2]))
      setSelectedFilters(existingFilters);
    }
  }

  const handleCustomToDate = (to) => {
    console.log(to.target.value)
    setCustomToDate(to.target.value)
    if(customFromDate) {
      let fromArr = customFromDate.split('-')
      let toArr = to.target.value.split('-')
      const existingFilters = { ...selectedFilters };
      existingFilters['toDate'] = to.target.value;
      existingFilters['fromDate'] = differenceInCalendarDays(new Date(toArr[0], toArr[1], toArr[2]), new Date(fromArr[0], fromArr[1], fromArr[2]))
      setSelectedFilters(existingFilters);
    }
  }

  const handleFilterClear = (filterName, filterValue) => {
    setFiltersLoading(true)
    handleFilterClearUtil(filterName, filterValue, selectedFilters, setSelectedFilters);
  };

  const handleExport = async () => {
    return generalStats(selectedFilters, true);
  };

  const getStatsData = async (selectedFilters) => {
    const stats = await generalStats(selectedFilters);
    setServerData(stats);
    setIsLoading(false);
    setFiltersLoading(false)
  };


  if (isLoading) {
    return <Loader />;
  }

  const {
    age_breakdown,
    gender_breakdown,
    living_breakdown,
    travel_breakdown,
    travel_word_cloud,
    deprivation_breakdown,
    ethnicity_breakdown,
    gender_identity_breakdown,
    sexual_orientation_breakdown
  } = serverData;

  return (
    <StatsJsx
      ageBreakdown={age_breakdown}
      genderBreakdown={gender_breakdown}
      livingBreakdown={living_breakdown}
      travelBreakdown={travel_breakdown}
      travel_word_cloud={travel_word_cloud}
      deprivationBreakdown={deprivation_breakdown}
      ethnicityBreakdown={ethnicity_breakdown}
      genderIdentityBreakdown={gender_identity_breakdown}
      sexualOrientalBreakdown={sexual_orientation_breakdown}
      selectedFilters={selectedFilters}
      handleFilterChange={handleFilterChange}
      handleFilterClear={handleFilterClear}
      handleExport={handleExport}
      isLoading={filtersLoading}
      customDateActive={customDateActive}
      handleCustomFromDate={handleCustomFromDate}
      handleCustomToDate={handleCustomToDate}
    />
  );
};

export default Stats;
